import React from "react";

// Custom
import Layout from "../../layout";
import CustomerMock from "./Customer";

const CustomerIndexMock: React.FC = () => {
  return (
    <Layout>
      <CustomerMock />
    </Layout>
  );
};

export default CustomerIndexMock;
